import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token }) => ({
  mark: {
    padding: '1.6px 4.8px !important',
    backgroundColor: token.colorWarningBorder,
    '>*': {
      backgroundColor: 'inherit !important'
    }
  },
  tooltipBody: {
    '*': {
      color: 'inherit !important'
    }
  }
}))
